import o from"styled-components";import{theme as r}from"../../../../../theme.js";const e=o.div`
  display: flex;
  flex-direction: column;
  gap: ${r.spacing*4}px;
  width: 100%;
  /* overflow-y: auto;
  max-height: calc(100vh - 196px); */
  /* @media screen and (max-width: ${r.breakpoints.lg}) {
    height: calc(100vh - 246px);
  } */
`,i=o.button`
  background-color: ${r.colors.gray[100]};
  border-radius: ${r.radius}px;
  padding: ${r.spacing*6}px;
  color: ${r.colors.gray[800]};
  font-size: 14px;
  font-weight: 700;
  border: 1px solid transparent;
  cursor: pointer;
  user-select: none;
  border: none;
  &.active {
    border: 1px solid ${r.colors.primary[500]};
  }
`;export{e as ListContainer,i as Wrapper};
